<template>
	<div class="form-group c-input-tags">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<component :is="dynamicComponent">
			<vue-tags-input
				:autocomplete-min-length="1"
				:maxLength="22"
				:max-tags="5"
				v-model="tag"
				:placeholder="placeholder"
				:tags="tags"
				:validation="validation"
				:autocompleteItems="items"
				@tags-changed="onTagsChanged"
			>
			</vue-tags-input>
		</component>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription
			v-if="description"
			:message="description"
		></InputDescription>
	</div>
</template>

<script>
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
	components: {
		InputError,
		InputDescription,
	},

	data: function () {
		return {
			tag: '',
			tags: [],
			validation: [],
		};
	},

	watch: {
		tags: {
			handler: function () {
				let tags = [];

				let temp = this.toShallow(this.tags);

				let condition = this.areArraysIdentical(this.value, temp);

				if (!condition) {
					tags = JSON.parse(JSON.stringify(this.tags));
					this.$emit('input', this.cleanTags(tags));
				}
			},
			immediate: false,
		},
		value: function () {
			let valueArr = this.value || [];

			let currentArr = this.tags || [];

			if (!this.value) {
				this.tags = [];
				return;
			}

			if (valueArr.length !== currentArr.length) {
				this.tags = this.value;
			}
		},
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		value: {},
		placeholder: {
			type: String,
			default: '+ Add tag',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
		// autocompleteItems: {
		// 	type: Array,
		// 	default: function () {
		// 		return [];
		// 	},
		// },
	},

	computed: {
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		dynamicComponent: function () {
			let standalone = this.$store.getters['standalone'];
			if (standalone) {
				return 'client-only';
			} else {
				return 'div';
			}
		},
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
		viewCache: function () {
			return this.$store.getters['ads/viewCache'];
		},
		items: function () {
			let items = [];

			let workspace = this.workspace || {};

			let workspaceTags = workspace.tags2 || [];

			for (let i = 0; i < workspaceTags.length; i++) {
				let wtag = workspaceTags[i];

				if (wtag.name) {
					items.push({
						text: wtag.name,
					});
				} else if (typeof wtag === 'string') {
					items.push({
						text: wtag,
					});
				}
			}

			// for (let i = 0; i < viewCache.length; i++) {
			// 	let tags = viewCache[i].tags;

			// 	if (tags) {
			// 		// ignore objects
			// 		for (let j = 0; j < tags.length; j++) {
			// 			if (typeof tags[j] === 'string') {
			// 				items.push({
			// 					text: tags[j],
			// 				});
			// 			}
			// 		}
			// 	}
			// }

			items = [...new Set(items)];

			// items = items.map((item) => {
			//   return {
			//     text: item,
			//   };
			// });

			if (!items) {
				items = [];
			}

			items.sort((a, b) => a.text.localeCompare(b.text));

			return items;
		},
	},

	methods: {
		areArraysIdentical(arr1, arr2) {
			// Check if arrays have the same length
			if (arr1.length !== arr2.length) {
				return false;
			}

			// Compare each element
			for (let i = 0; i < arr1.length; i++) {
				if (arr1[i] !== arr2[i]) {
					return false;
				}
			}

			return true;
		},
		toShallow: function (arr = []) {
			arr = JSON.parse(JSON.stringify(arr));
			arr = arr.map((item) => {
				if (item.text) {
					return item.text;
				}
				return item;
			});

			return arr;
		},
		onTagsChanged: function (newTags) {
			this.tags = newTags;
		},
		cleanTags: function (tags) {
			for (let i = 0; i < tags.length; i++) {
				if (tags[i].tiClasses) {
					delete tags[i].tiClasses;
				}
				if (tags[i].text) {
					tags[i] = tags[i].text;
				}
			}

			return tags;
		},
	},

	mounted: function () {
		if (this.value) {
			let tags = this.value;

			tags = tags.map((tag) => {
				if (typeof tag === 'string') {
					return {
						text: tag,
					};
				}
				return tag;
			});

			this.tags = tags;
		}
	},
};
</script>

<style lang="scss">
.c-input-tags {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);

	> div {
		width: 100%;
	}

	.vue-tags-input {
		margin-bottom: var(--margin);
		width: 100%;
		max-width: initial;
		background-color: transparent !important;

		.ti-input {
			border: none;
			//min-height: 50px;
			padding: 0;
		}
		.ti-autocomplete {
			overflow: hidden;
			font-size: var(--font-size-xs);

			background-color: var(--color-bg-1);
			border-radius: var(--border-radius);
			border: none;
			box-shadow: var(--item-box-shadow);
			padding: var(--margin-sm);

			li {
				display: inline-block;
				position: relative;
				background-color: var(--color-bg-4);
				padding: 5.5px 8px;
				margin-top: 0;
				margin-right: 4px;
				margin-bottom: 4px;
				font-size: var(--font-size-xs);
				line-height: 1;
				border-radius: var(--border-radius);
				cursor: pointer;
				transition: all var(--transition-time-sm) ease-out;

				&:before {
					content: none;
				}

				&:after {
					content: '';
					display: block;
					position: absolute;
					top: calc(50% - 2px);
					right: 6px;
					width: 4px;
					height: 4px;
					background-color: currentColor;
					border-radius: 2px;
				}

				&:hover,
				&:focus,
				&.active,
				&.ti-selected-item {
					outline: none;
					background-color: var(--color-primary);
					color: var(--color-button-font);
				}
			}
		}
		.ti-tag {
			margin: 0;
			margin-right: 4px;
			margin-bottom: 4px;
			max-height: 26px;
			cursor: pointer;
			padding: var(--margin) var(--spacer-sm);
			padding-right: var(--margin-lg);
			color: var(--color-font);
			background-color: var(--color-bg-4);
			border-radius: var(--border-radius);

			display: flex;
			justify-content: center;
			align-items: center;

			letter-spacing: 0.3px;
			font-size: var(--font-size-sm);

			&.ti-deletion-mark {
				color: var(--color-button-font);
			}

			&:hover,
			&:active {
				opacity: 0.85;
			}

			&:before {
				content: none;
			}
		}
		.ti-tags {
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			//min-height: 33.5px;
			line-height: 1em;
			//padding: var(--margin);
			border-radius: 9px;
			border: var(--color-input-background) solid 1px;
			padding: 4px 4px 0 4px;
			background-color: transparent;
			background-color: var(--color-bg-2);
			list-style: none;
			box-sizing: border-box;

			.ti-actions {
				i {
					transition: background-color var(--transition-time) linear;
					&:hover {
						background-color: rgba(0, 0, 0, 0.1);
					}
				}
			}

			.ti-new-tag-input-wrapper {
				min-height: 26px;
				display: block;
				//display: flex;
				//flex: 1 0 auto;
				font-size: var(--font-size);
				margin: 0;
				margin-right: 0;
				margin-bottom: 4px;
				padding: 0;
				background-color: transparent;
				margin-top: -1px;

				&:before {
					content: none;
				}

				input {
					padding: var(--margin) var(--margin-lg);
					-webkit-appearance: none;
					background-color: transparent;
					color: var(--color-font);
					font-size: var(--font-size-sm);
					width: 100%;
					box-sizing: border-box;
					border: none;
					border-radius: var(--border-radius);

					&:focus {
						border-color: var(--color-input-background-light);
						border-color: hsl(var(--p), 100%, 55%);
						box-shadow: 0 0 0 3px hsla(var(--p), 100%, 60%, 0.45) !important;
						outline: none;
					}
				}
			}
		}

		[class^='ti-icon-'] {
			font-family: 'icomoon' !important;
			speak: none;
			font-style: normal;
			font-weight: normal;
			font-variant: normal;
			text-transform: none;
			line-height: 1;
			-webkit-font-smoothing: antialiased;
		}
		.ti-icon-close {
			&:before {
				content: '\e901';
			}
		}
	}
}
</style>
